export default __webpack_public_path__ + "static/media/address-concept-illustration_114360-321.3a7a19a6.jpg";